import { render, staticRenderFns } from "./NewProjectSearchBar.vue?vue&type=template&id=4baa1c06&scoped=true"
import script from "./NewProjectSearchBar.vue?vue&type=script&lang=js"
export * from "./NewProjectSearchBar.vue?vue&type=script&lang=js"
import style0 from "./NewProjectSearchBar.vue?vue&type=style&index=0&id=4baa1c06&prod&lang=css"
import style1 from "./NewProjectSearchBar.vue?vue&type=style&index=1&id=4baa1c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa1c06",
  null
  
)

export default component.exports